import {
    getAnnualReturnUsingRiskScore,
    HomeDownPaymentGoal,
} from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getProgressUsingTargetAmount } from '../helpers';
import { BaseGoalConfig } from './types';

export const HOME_DOWN_PAYMENT: BaseGoalConfig<HomeDownPaymentGoal> = {
    iconName: 'GoalHome',
    color: colorsByGoalType['HOME_DOWN_PAYMENT'].primary,
    defaultName: 'Home down payment',
    getDescription: () => 'A house that becomes a home.',
    group: 'INVEST',
    blogLink: {
        description: 'See Plenty’s guide on buying a home',
        url: 'https://www.withplenty.com/blog/buying-your-first-home-what-you-need-to-know',
    },
    getAnnualReturn: getAnnualReturnUsingRiskScore,
    getProgress: (config) => getProgressUsingTargetAmount(config),
};
